import { FetchFn } from '@wix/thunderbolt-symbols/dist'

export function buildEphemeralFetchFn(originalRequestBody: string, fetchFn: FetchFn): FetchFn {
	return async (url: string, init?: RequestInit) => {
		return fetchFn(buildRequestUrl(url), buildRequestInit(originalRequestBody, init))
	}
}

function buildRequestInit(body: string, requestInit?: RequestInit): RequestInit {
	const init = { ...(requestInit || {}) }
	init.method = 'POST'
	init.body = body
	return init
}

function buildRequestUrl(url: string): string {
	const urlObj = new URL(url)
	urlObj.searchParams.set('local', 'true')
	return urlObj.toString()
}
